
























import hash from 'object-hash';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { mapActionsDvm, mapMutationsDvm } from '@/main/pages';
import { EditableStatus } from '@/main/utils/table';
import { deleteButton } from '@/main/utils/tableOperations';
import { EditStoreMixin } from '@/main/pages/editStoreMixin';
import _ from 'lodash';
// eslint-disable-next-line no-unused-vars
import { DropdownItem } from '@/main/store/@types/dropdown.d';

// eslint-disable-next-line no-unused-vars
import { ProvozovnaIdDropDownList, store } from '../store/edit';
// eslint-disable-next-line no-unused-vars
import { ProvozovnyType } from '../store/types';

export default EditStoreMixin.extend({
	name: 'Provozovny',
	props: {
		disabled: { type: Boolean },
	},
	computed: {
		...genVuexComputeds(store),
		table(): {} {
			return this.Provozovny.filter((item) => item.UpdateStatus !== EditableStatus.DELETED);
		},
		extraButtons(): {} {
			return {
				...deleteButton((e: any, row: ProvozovnyType) => this.deleteItem(row)),
			};
		},
		filteredProvozovny(): DropdownItem[] {
			return this.dropdownList.ProvozovnaId.filter(
				(item) => !this.Provozovny.some((i) => i.UpdateStatus !== EditableStatus.DELETED && i.ProvozovnaId === item.Value),
			);
		},
		columnKey(): string {
			return hash(this.filteredProvozovny.map(({ Value }) => Value));
		},
		tableKey(): string {
			return hash(this.Provozovny.filter((i) => i.UpdateStatus !== EditableStatus.DELETED).map(({ ProvozovnaId }) => ProvozovnaId));
		},
	},
	methods: {
		...mapActionsDvm(store.actions),
		...mapMutationsDvm(store.mutations),
		deleteItem(row: ProvozovnyType) {
			if (row.UpdateStatus === EditableStatus.UNMODIFIED) {
				row.UpdateStatus = EditableStatus.DELETED;
			} else {
				const deleted = this.dropdownList.ProvozovnaId.find((i) => i.Value === row.ProvozovnaId);
				deleted!.selected = false;
				this.Provozovny = this.Provozovny.filter((i) => i.ProvozovnaId !== row.ProvozovnaId);
			}
		},
		addItems() {
			const newProvozovne = this.dropdownList.ProvozovnaId.filter((item) => item.selected).map((item) => ({
				AktualizacePrp: false,
				ProvozovnaId: item.Value,
				UpdateStatus: EditableStatus.INSERTED,
			}));
			_.intersectionBy(this.Provozovny, newProvozovne, 'ProvozovnaId').forEach((i) => {
				i.UpdateStatus === EditableStatus.DELETED && (i.UpdateStatus = EditableStatus.UNMODIFIED);
			});
			this.Provozovny = _.unionBy(this.Provozovny, newProvozovne, 'ProvozovnaId');
		},
		getProvozovnaText(provozovnaId: number): string {
			return this.dropdownList.ProvozovnaId.find((item) => item.Value === provozovnaId)?.Text ?? provozovnaId.toString();
		},
		editableCheck(row: ProvozovnyType, checked: boolean) {
			row.AktualizacePrp = checked;

			if (row.UpdateStatus === EditableStatus.UNMODIFIED) row.UpdateStatus = EditableStatus.MODIFIED;
		},
		selectItem(selected: boolean, prov: ProvozovnaIdDropDownList) {
			this.dropdownList.ProvozovnaId.find((i) => i.Value === prov.Value)!.selected = selected;
		},
		getLocalized(text: string) {
			return this.LocalizePopisostatni(text);
		},
	},
});
